import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import {
  useHandlers,
  withPageProviders,
} from '@sparklayer-io/spark-dash-pages/context/page-context';
import { Page } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { Onboarding } from '../components/onboarding/onboarding';
import { OnboardingActions } from '../components/onboarding-actions';
import { UpsellPlan } from '../components/upsell-plan';
import { DOCS_URLS, TEAM_PATH } from '../constants';

const PAGE = 'features:home.pages.settings_setup_page' satisfies I18nPrefix;

export const SettingsSetupPage = withPageProviders(SettingsSetupPageContent);

function SettingsSetupPageContent() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();
  const websiteDomain = env.team.website.replace(/^https?:\/\//, '');

  return (
    <Page
      title={t(`${PAGE}.header.title`)}
      description={
        <>
          {t(`${PAGE}.header.description`, { environment: env.environment })}{' '}
          <span className="italic">{websiteDomain}</span>.
        </>
      }
      learnMoreUrl={DOCS_URLS.gettingStarted}
      footerDescription={t(`${PAGE}.header.footer`)}
      secondaryActions={[
        {
          label: t(`${PAGE}.header.invite_partner`),
          icon: 'userAdd',
          onClick: () => navigationHandler.navigate(TEAM_PATH, { excludeSiteEnv: true }),
        },
      ]}
    >
      <Onboarding />
      <OnboardingActions />
      <UpsellPlan />
    </Page>
  );
}
